var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import "./resizable.css";
import "../core/polyfills";
import { EventHandler } from "./eventhandler";
var defaultOptions = {
    resizeHandlePrefix: "rs-",
    onStart: new EventHandler(),
    onStop: new EventHandler(),
    onResize: new EventHandler(),
    resizeDelta: 0
};
var ResizeContainer = /** @class */ (function () {
    function ResizeContainer(container, options) {
        var _this = this;
        this.container = container;
        this.options = options;
        this.startSize = { x: null, y: null };
        this.mouseDownContainer = function (evt) {
            var target = evt.target;
            if ((" " + target.className).indexOf(" " + _this.options.resizeHandlePrefix) < 0) {
                return; // not a resize handle
            }
            evt.preventDefault();
            evt.stopPropagation();
            evt.stopImmediatePropagation();
            _this.resizeX = target.classList.contains(_this.options.resizeHandlePrefix + "r") ||
                target.classList.contains(_this.options.resizeHandlePrefix + "l");
            _this.resizeY = target.classList.contains(_this.options.resizeHandlePrefix + "t") ||
                target.classList.contains(_this.options.resizeHandlePrefix + "b");
            _this.element = target.parentElement; // TODO change to closest class
            _this.options.onStart.notify({ evt: evt, target: _this.element, x: _this.extractArg(evt, "pageX"), y: _this.extractArg(evt, "pageY") });
            // register event listeners
            window.addEventListener("mousemove", _this.mouseMove, false);
            window.addEventListener("mouseup", _this.mouseUp, false);
            window.addEventListener("touchmove", _this.mouseMove, false);
            window.addEventListener("touchend", _this.mouseUp, false);
        };
        this.mouseMove = function (evt) {
            var raiseEvt = false;
            if (_this.resizeX) {
                var val = _this.extractArg(evt, "clientX") - _this.element.getBoundingClientRect().left;
                if (_this.options.minWidth && val < _this.options.minWidth) {
                    val = _this.options.minWidth;
                }
                else if (_this.options.maxWidth && val > _this.options.maxWidth) {
                    val = _this.options.maxWidth;
                }
                if (_this.startSize != null && _this.startSize.x == null) {
                    _this.startSize.x = val;
                }
                if (_this.startSize == null || Math.abs(_this.startSize.x - val) >= _this.options.resizeDelta) {
                    // if (!this.options.gridX || Math.round(val) % this.options.gridX === 0) {
                    if (_this.options.gridX) {
                        val = Math.round(val / _this.options.gridX) * _this.options.gridX;
                    }
                    _this.element.style.width = Math.round(val) + "px";
                    raiseEvt = true;
                    _this.startSize = null;
                    // }
                }
            }
            if (_this.resizeY) {
                var val = _this.extractArg(evt, "clientY") - _this.element.getBoundingClientRect().top;
                if (_this.options.minHeight && val < _this.options.minHeight) {
                    val = _this.options.minHeight;
                }
                else if (_this.options.maxHeight && val > _this.options.maxHeight) {
                    val = _this.options.maxHeight;
                }
                if (_this.startSize != null && _this.startSize.y == null) {
                    _this.startSize.y = val;
                }
                if (_this.startSize == null || Math.abs(_this.startSize.y - val) >= _this.options.resizeDelta) {
                    // if (!this.options.gridY || Math.round(val) % this.options.gridY === 0) {
                    if (_this.options.gridY) {
                        val = Math.round(val / _this.options.gridY) * _this.options.gridY;
                    }
                    _this.element.style.height = Math.round(val) + "px";
                    raiseEvt = true;
                    _this.startSize = null;
                    // }
                }
            }
            if (raiseEvt) {
                _this.options.onResize.notify({ evt: evt, target: _this.element, x: _this.extractArg(evt, "pageX"), y: _this.extractArg(evt, "pageY") });
            }
        };
        this.mouseUp = function (evt) {
            window.removeEventListener("mousemove", _this.mouseMove, false);
            window.removeEventListener("mouseup", _this.mouseUp, false);
            window.removeEventListener("touchmove", _this.mouseMove, false);
            window.removeEventListener("touchend", _this.mouseUp, false);
            _this.options.onStop.notify({ evt: evt, target: _this.element, x: _this.extractArg(evt, "pageX"), y: _this.extractArg(evt, "pageY") });
            _this.startSize = { x: null, y: null };
        };
        this.init();
    }
    ResizeContainer.prototype.init = function () {
        this.container.classList.add("resizable");
        this.container.addEventListener("mousedown", this.mouseDownContainer, false);
        this.container.addEventListener("touchstart", this.mouseDownContainer, false);
    };
    ResizeContainer.prototype.extractArg = function (evt, key) {
        return evt[key] != null ? evt[key] : (evt.touches.length > 0 ? evt.touches : evt.changedTouches)[0][key];
    };
    return ResizeContainer;
}());
export { ResizeContainer };
export function Resizable(selector, options) {
    return new ResizeContainer(typeof selector === "string" ?
        document.querySelector(selector) :
        selector, __assign(__assign({}, defaultOptions), options));
}
